@let key = messageKey();

@if (key) {
  <div
    #banner
    class="connection-status-banner typography-small-medium"
    [class.connection-status-banner--restored]="status() === 'restored'"
    animate.enter="connection-status-banner--enter"
    animate.leave="connection-status-banner--leave"
    data-testid="connection-status-banner"
    role="status"
    aria-live="polite"
  >
    {{ key | translate }}
  </div>
}
